import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
const URL = 'https://arit.rmutl.ac.th/survey/api/'
// const URL = 'http://localhost/aritsurvey/api/'
export default {
  DataStudent (obj, success, error) {
    Vue.axios.post(URL + 'online/student', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  DataChoice (obj, success, error) {
    Vue.axios.post(URL + 'online/sectionstudentans', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCampus (success, error) {
    Vue.axios.get(URL + 'campus').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getFaculty (success, error) {
    Vue.axios.get(URL + 'facultys').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDepartment (id, success, error) {
    Vue.axios.get(URL + 'department/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getMajor (id, success, error) {
    Vue.axios.get(URL + 'major/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/index.js